export const ARIA_TENANT_TOKENS = [
    '56468f6991c348029c6bba403b444607-2cc7a802-0cc9-4c56-a5c7-539f55b73f11-6967',
];
